import { createSelector } from 'reselect'

import interactiveVideoSelectors from 'redux/selectors/interactive_videos'

const getInteractiveVideoSession = state => state.interactiveVideo
const identitySelector = interactiveVideoSelectors.interactiveVideoIdentitySelector

export default createSelector(
	[
		getInteractiveVideoSession,
		identitySelector,
	],
	(interactiveVideo, interactiveVideoIdentity) => ({
		jwt: interactiveVideoIdentity.jwt,
		uid: interactiveVideoIdentity.uid,
		mediaUid: interactiveVideo.media.uid,
		posterUid: interactiveVideo.media.posterUid,
		nickname: interactiveVideo.nickname,
		sessionType: interactiveVideo.sessionType,
		role: interactiveVideo.role,
		isGuest: interactiveVideo.isGuest,
		externalUid: interactiveVideo.externalUid,
		videoUid: interactiveVideo.media.asset.uid,
	})
)
